import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

window.onload = function() {
    const spinner: HTMLElement = <HTMLElement>document.getElementById('loading');
    spinner.classList.add('loaded');

    const objNavSp = document.getElementById('nav');
    if(objNavSp) {
        objNavSp.classList.remove('preload');
    }
};

// SP
function isSmartPhone() : boolean {
    return document.body.clientWidth <= 768;
}

// userAgent
let userAgent = window.navigator.userAgent.toLowerCase();

// TOP - get window.innerHeight and set value to css '--vh'
if(isSmartPhone()) {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
}


// MENU
const objmenu: HTMLElement = <HTMLElement>document.querySelector('.header-nav'),
    objNav: HTMLElement = <HTMLElement>document.querySelector('.nav'),
    objHeadOuter: HTMLElement = <HTMLElement>document.querySelector('.header-title-outer');

function noScroll(event:any) {
    event.preventDefault();
}

if(objmenu) {
    objmenu.addEventListener("click", function () {
        toggleMenu()
    });
    objNav.addEventListener("click", function () {
        toggleMenu();
    });
    let toggleMenu = function() {
        objmenu.classList.toggle("active");
        objNav.classList.toggle("active");
        objHeadOuter.classList.toggle("navActive")
        document.body.classList.toggle('noScroll');
        if (document.body.classList.contains('noScroll')) {
            (<any>document).addEventListener('touchmove', noScroll, { passive: false });
            (<any>document).addEventListener('mousewheel', noScroll, { passive: false });
        } else {
            (<any>document).removeEventListener('touchmove', noScroll, { passive: false });
            (<any>document).removeEventListener('mousewheel', noScroll, { passive: false });
        }
    }
}

// works
const objWorksCategorySelect: NodeList = <NodeListOf<HTMLDivElement>>document.querySelectorAll('.btn-work-category'),
    objWorks: NodeList = <NodeListOf<HTMLDivElement>>document.querySelectorAll('.work'),
    objWorksNoData: HTMLElement = <HTMLElement>document.getElementById('noData');

if (objWorksCategorySelect) {
    objWorksCategorySelect.forEach((element) => {
        (<any>element).addEventListener('click', function (event: Event) {
            let dataCategory : string = '';
            let objTitle = event.currentTarget as HTMLDivElement;
            if(objTitle.dataset.key !== undefined) {
                dataCategory = objTitle.dataset.key;
            }
            objTitle.classList.add('active');
            (<any>objWorksCategorySelect).forEach(function (work:HTMLDivElement) {
                if(work !== objTitle) {
                    work.classList.remove('active');
                }
            });
            let counter = 0;
            for (let work of Array.from(objWorks) as HTMLDivElement[]) {
                if(dataCategory !== '') {
                    if (work.classList.contains(dataCategory)) {
                        work.classList.remove('hidden');
                        counter++;
                    } else {
                        work.classList.add('hidden');
                    }
                } else {
                    work.classList.remove('hidden');
                    counter++;
                }
            }
            if(dataCategory !== '' && counter === 0) {
                objWorksNoData.classList.remove('hidden');
            } else {
                objWorksNoData.classList.add('hidden');
            }
        });
    });
}